import React from "react";
import { io } from "socket.io-client";
import Config from "../Config";

export const socket = io(Config.SOCKET_URL, {
    withCredentials: false,
});
export const SocketContext = React.createContext();
